import { callAPI } from 'Action';
import { appConstantUrl } from 'appConstant';
import { MANUAL_MASTER_DATA } from './types';

export const masterDataManual = () => async (dispatch: any) => {
  let url = appConstantUrl.masterDataUrl;

  const options = {
    url,
    method: 'GET',
    dispatch: null,
  };
  let data = await callAPI(options);
  if (data) {
    dispatch({
      type: MANUAL_MASTER_DATA,
      payload: data,
    });
  }
};
